export default __webpack_public_path__ + "c9c449392988b79201dbb19e7ec607b2.svg";